import axios from "axios";
import Swiper from "swiper";
import SwiperCore, { Navigation, Pagination } from 'swiper/core';
SwiperCore.use([Navigation, Pagination]);

export default () => {
    const swipers = document.querySelectorAll(".collections-swiper-container");

    swipers.length >0? useSwiper():false;

    function useSwiper() {

        let data;
        let newArray
        axios.get('/?view=json').then((response) => {
            data = response.data.collections; 
        }). then(() =>{
            data.sort(function(a, b) {
                if (a.order < b.order) return -1;
                if (a.order > b.order) return 1;
                return 0;
                });
            newArray = data;
        }). then(()=>{
            newArray.forEach(item =>{
                let div = document.createElement('div');
                
                div.className = "collections-slide swiper-slide";
                div.innerHTML = `<a class="collections-slide__inner" href="${item.url}">
                <div class="collections-text-wrapper"><h3 class="collections-title">
                ${item.title}</h3><p class="collections-name">${item.vendor}</p></div><div class="collections-img"><img src="${item.image}" alt=""></div></a>`;
                document.querySelector('[data-append]').append(div);
                })
            
        }).then(()=>{
            swipers.forEach(slider =>{
                const swiper = new Swiper(slider, {
                    breakpoints: {
                        
                        0: {
                            slidesPerView: 1.43,
                            spaceBetween: 0,
                        },
                        640: {
                            slidesPerView: 2,
                            spaceBetween: 0,
                        },
                        1024: {
                            slidesPerView: 3,
                            spaceBetween: 0,
                        },
                        1800: {
                            slidesPerView: 4,
                        }
                    },
                    slidesPerView: 3,
                    mousewheel: {
                        releaseOnEdges: true,
                    },
                    freeMode: true,
                    allowTouchMove: true,
                    navigation: {
                        nextEl: '.swiper-button-next',
                        prevEl: '.swiper-button-prev',
                        },
                    });
            })
        })
    }
};